
import Overlay from 'ol/Overlay';
import Modify from 'ol/interaction/Modify';

export default class OlMapPlugin {

    constructor(options) {
        this._options = options || {};
    }

    getOlMap() {
        return this._options.olMap;
    }

    getMap() {
        return this.getOlMap().getMap();
    }

    init() {
        let map = this.getMap();

        let tooltip = new Overlay({
            element: document.createElement('div'),
            positioning: 'bottom-center',
            stopEvent: false,
            offset: [0, -8],
        });
        map.addOverlay(tooltip);

        tooltip.getElement().style.backgroundColor = 'rgb(50, 52, 54)';
        tooltip.getElement().style.padding = '0.2em 0.4em';
        tooltip.getElement().style.borderRadius = '1em'

        map.on('pointermove', function (evt) {
            let feature = map.forEachFeatureAtPixel(evt.pixel, (feature) => {
                return feature.get('nazev') ? feature : null;
            });
            if (feature) {
                tooltip.setPosition(evt.coordinate);
                tooltip.getElement().innerHTML = feature.get('nazev');
            }
            tooltip.getElement().style.display = feature ? '' : 'none';
            map.getTarget().style.cursor = feature ? 'pointer' : '';
        });
    }

    initInteractions(onMapToolExecute) {
        let modify = new Modify({
            source: this.getOlMap().getLayerById('useky').getSource()
        });

        modify.set('mapToolId', 'ModifyFeature');
        modify.setActive(false);

        modify.on('modifyend', (e) => {
            if (onMapToolExecute) {
                if (e.features.getLength() > 0) {
                    onMapToolExecute(
                        modify.get('mapToolId'),
                        {
                            feature: e.features.item(0)
                        }
                    );
                }
            }
        });

        this.getMap().addInteraction(modify);
    }
}
